/**
 * @generated SignedSource<<d8498d563d2920fd23eb64958ff4dc59>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WebAppWrapper_viewer$data = {
  readonly id: string;
  readonly user: {
    readonly id: string;
    readonly orgs: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly userWorkingHours: {
            readonly workingHours: {
              readonly timeZone: string | null;
            } | null;
          } | null;
        } | null;
      } | null> | null;
    };
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"WebAppNav_viewer">;
  readonly " $fragmentType": "WebAppWrapper_viewer";
};
export type WebAppWrapper_viewer$key = {
  readonly " $data"?: WebAppWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"WebAppWrapper_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WebAppWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WebAppNav_viewer"
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1000000
            }
          ],
          "concreteType": "OrgConnection",
          "kind": "LinkedField",
          "name": "orgs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrgEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Org",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UserWorkingHours",
                      "kind": "LinkedField",
                      "name": "userWorkingHours",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "WorkingHours",
                          "kind": "LinkedField",
                          "name": "workingHours",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "timeZone",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "orgs(first:1000000)"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "31d2b7670e48e6ba837606ba113ed819";

export default node;
